import React, { useContext, useState } from "react";
import styled from "styled-components";
import EmailIco from "../../../assets/icons/email-ico.svg";
import UserIco from "../../../assets/icons/user-ico.svg";
import { ReactComponent as NavigateArrow } from "../../../assets/icons/navigate-arrow.svg";
import BOstageBLogo from "../../../assets/images/BOstageB-logo.png";
import BOstageRLogo from "../../../assets/images/footer-logologin.png";
import HelpCircle from "@untitled-ui/icons-react/build/esm/HelpCircle";
import CreditCard02 from "@untitled-ui/icons-react/build/esm/CreditCard02";
import Power01 from "@untitled-ui/icons-react/build/esm/Power01";
import { useNavigate } from "react-router";
import AppContext from "../../../AppContext";

//#region SCOPED CSS
const StyledDiv = styled.div`
    &.main-user-profile {
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 272px;
        width: 230px;
    }
    .frame-user-profile {
        display: flex;
        justify-content: flex-start;
        gap: 8px;
        padding: 8px;
        font-size: 12px;
        font-weight: 400;
        align-items: center;
        height: 32px;
        cursor: pointer;
    }
    .frame-user-profile:hover {
        background-color: #1e2631;
    }
    .frame-user-profile.hover-not-allowed:hover {
        cursor: not-allowed !important;
    }
    .frame-user-profile.border-bottom {
        border-bottom: 2px solid #1a222d;
    }
    .frame-user-profile.disabled {
        cursor: not-allowed !important;
        color: var(--text-icons-gray-300);
    }
    .profile-email-icon {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .switch-plan-group {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        height: 9px;
    }
    .switch-plan-text {
        font-size: 8px;
        font-weight: 500;
        text-transform: uppercase;
    }
    .switch-plan-divider {
        width: 145px;
        height: 0;
        border: 1px solid #1a222d;
    }
    .brand-logo img {
        width: 68px;
        height: 18.51px;
        object-fit: cover;
    }
    .brand-logo.disabled img {
        filter: grayscale(100%);
        opacity: 0.3;
    }
    .brand-nav-arrow img {
        height: 10px;
        width: 10px;
    }
    .brand-bostage-logo-arrow {
        display: flex;
        justify-content: space-between;
        height: 26.41px;
        cursor: pointer;
        padding: 0px 8px;
    }
    .brand-bostage-logo-arrow.disabled {
        filter: grayscale(100%);
        opacity: 0.3;
        cursor: not-allowed;
    }
    .brand-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 52.91px;
    }
    .switch-logo-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 72px;
    }
    .divider {
        width: 100%;
        border: 1px solid #1a222d;
    }
    .profile-billing-help {
        height: 96px;
        display: flex;
        flex-direction: column;
    }
    .arrow-action {
        color: "#D1D1D1";
    }
`;
//#endregion

export default function UserProfileDropdown({ handleLogoutBtnClick, setShowUserProfileDropdown }) {
    //#region VARS
    const navigate = useNavigate();
    const { userData } = useContext(AppContext);
    // Check if BOstageR exists in platforms
    const hasBOstageB = userData?.organization?.platforms?.some(p => p.platformName === "BOstageB");
    const [disableHelpCenter] = useState(true);
    //#endregion

    return (
        <StyledDiv className="main-user-profile">
            <div className="frame-user-profile border-bottom">
                <div className="profile-email-icon">
                    <img src={EmailIco} alt="" />
                </div>
                <div className="profile-user-email">{localStorage.getItem("userEmail")}</div>
            </div>
            <div className="profile-billing-help">
                <div className="frame-user-profile hover-not-allowed">
                    <div className="profile-email-icon">
                        <img src={UserIco} alt="" />
                    </div>
                    <div className="profile-user-email">Profile</div>
                </div>
                <div
                    className="frame-user-profile"
                    onClick={() => {
                        navigate("/billing");
                    }}>
                    <div className="profile-email-icon">
                        <CreditCard02 height="100%" width="16px" />
                    </div>
                    <div className="profile-user-email">Billing</div>
                </div>
                <div
                    className={`frame-user-profile ${
                        disableHelpCenter ? "disabled hover-not-allowed" : "hover-pointer"
                    }`}
                    onClick={disableHelpCenter ? null : () => navigate("/support")}>
                    <div className="profile-email-icon">
                        <HelpCircle height="100%" width="16px" />
                    </div>
                    <div className="profile-user-email">Help Center</div>
                </div>
            </div>
            <div className="switch-logo-group">
                <div className="switch-plan-group">
                    <div className="switch-plan-text">Switch PLATFORM</div>
                    <div className="switch-plan-divider"></div>
                </div>

                <div className="brand-group">
                    <div
                        className={`brand-bostage-logo-arrow ${hasBOstageB ? "" : "disabled"}`}
                        onClick={() => {
                            if (hasBOstageB) {
                                window.open(`${process.env.REACT_APP_BOSTAGE_B_URL}`, "_blank");
                            }
                        }}>
                        <div className="brand-logo">
                            <img src={BOstageBLogo} alt="Bostage Logo Arrow" />
                        </div>
                        <div className="brand-nav-arrow">
                            <NavigateArrow className="arrow-action" />
                        </div>
                    </div>
                    <div className="brand-bostage-logo-arrow disabled">
                        <div className="brand-logo">
                            <img src={BOstageRLogo} alt="Bostage Logo Arrow" />
                        </div>
                        <div className="brand-nav-arrow">
                            <NavigateArrow className="arrow-action" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="divider"></div>
            <div>
                <div
                    className="frame-user-profile"
                    onClick={() => {
                        handleLogoutBtnClick();
                        setShowUserProfileDropdown(false);
                    }}>
                    <div className="profile-email-icon">
                        <Power01 className="text-green-500" height="16px" />
                    </div>
                    <div className="profile-user-email">Sign Out</div>
                </div>
            </div>
        </StyledDiv>
    );
}
